import { styled } from '@mui/material/styles';

export const HiddenInput = styled('input')({
  display: 'none',
});
